import React from 'react';
import { AudioLines, Music2, Sparkles } from 'lucide-react';
import NorthernLights from './NorthernLights';

const LoadingBar = ({ delay = '0ms' }) => (
  <span
    className="block h-full w-1.5 rounded-full bg-eduvibe-green shadow-[0_0_18px_rgba(47,234,155,0.55)] animate-pulse"
    style={{ animationDelay: delay }}
  />
);

const LoadingScreen = ({
  title = 'Loading EduVibz',
  subtitle = 'Tuning your study music...',
  compact = false,
  className = ''
}) => (
  <div className={`relative flex min-h-[60vh] items-center justify-center overflow-hidden bg-[#020817] px-4 py-16 text-white ${className}`}>
    <NorthernLights />
    <div className={`relative z-10 w-full ${compact ? 'max-w-md' : 'max-w-2xl'} rounded-3xl border border-eduvibe-blue/20 bg-[#061a34]/72 p-6 text-center shadow-[0_24px_100px_rgba(0,0,0,0.30)] backdrop-blur-xl md:p-8`}>
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-eduvibe-green/25 bg-eduvibe-green/10 text-eduvibe-green shadow-[0_0_36px_rgba(47,234,155,0.18)]">
        <AudioLines className="h-8 w-8" aria-hidden="true" />
      </div>
      <div className="mx-auto mt-5 flex h-16 items-end justify-center gap-2" aria-hidden="true">
        <LoadingBar />
        <LoadingBar delay="120ms" />
        <LoadingBar delay="240ms" />
        <LoadingBar delay="360ms" />
        <LoadingBar delay="480ms" />
        <LoadingBar delay="600ms" />
      </div>
      <div className="mt-5 flex items-center justify-center gap-2 text-eduvibe-green">
        <Music2 className="h-5 w-5" aria-hidden="true" />
        <Sparkles className="h-5 w-5" aria-hidden="true" />
      </div>
      <h1 className="mt-4 text-2xl font-black text-white md:text-3xl">{title}</h1>
      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-white/62 md:text-base">{subtitle}</p>
    </div>
  </div>
);

export default LoadingScreen;
